import React from 'react';
import { ConnectedSegmentManager } from './SegmentManager';
import { ConnectedSegmentManagerRoundTrip } from './SegmentManagerRoundTripDesktop';
import { ConnectedSegmentManagerDefaultDesktop } from './SegmentManagerDefaultDesktop';

export const SegmentManagerDesktop = () => (
    <ConnectedSegmentManager render={
        (isRoundTrip) => isRoundTrip ? (
            <ConnectedSegmentManagerRoundTrip />
        ): <ConnectedSegmentManagerDefaultDesktop />
    }
    />
);
